import { ChangeControlSeverity } from 'src/generated/graphql';
import { ActiveChangeControlWindow } from './useChangeControlStatus';

/**
 * Resource ids for the accessible name of the status icon on both change-control
 * surfaces — the app-wide banner (`toFlashbarItem`) and the inline edit notice
 * (`ChangeControlEditNotice`).
 *
 * Neither surface renders a header and both use body copy that is identical
 * across severities, so this label is the only place a screen reader hears the
 * severity named: Cloudscape renders the status icon aria-hidden unless given a
 * label, and the app installs no Flashbar/Alert `i18nStrings` (nor an
 * `I18nProvider`) to supply one.
 *
 * Shared by the two surfaces so they cannot drift apart, and kept as a map so it
 * can be asserted exhaustively alongside `FLASH_TYPE` / `ALERT_TYPE`.
 */
export const STATUS_ICON_ARIA_LABEL_IDS: Record<
  ActiveChangeControlWindow['severity'],
  string
> = {
  [ChangeControlSeverity.Blocked]: 'status-icon-error',
  [ChangeControlSeverity.Restricted]: 'status-icon-warning',
};
